export const raw_material_order_item_statuses =  [
  {id:0, name: 'Pending', color: '', is_visible: true},
  {id:1, name: 'Not Accepted', color: '#f8961e', is_visible: true},
  {id:2, name: 'Accepted', color: '#f8961e', is_visible: true},
  {id:3, name: 'Pending Dispatch', color: '#f9c74f', is_visible: true},
  {id:4, name: 'Not Dispatched', color: '#f72585', is_visible: true},
  {id:5, name: 'Dispatched', color: '#006d77', is_visible: true},
  {id:6, name: 'Not Received', color: '#f72585', is_visible: false},
  {id:7, name: 'Received', color: '#006d77', is_visible: false},
  {id:8, name: 'Returned', color: '#3a0ca3', is_visible: false},
  {id:6, name: 'Cancelled', color: '#d62828', is_visible: true},
];


export const raw_material_order_statuses =  [
  {id: 2, name: 'All Accepted', slug: 'all_accepted', color: '#f8961e', is_partial_status: false,
    before_status: ['Order Submitted'], item_status: '', is_visible: true
  },
  {id: 3, name: 'Part Accepted', slug: 'part_accepted', color: '#f9844a', is_partial_status: true,
    before_status: ['Order Submitted', 'Part Accepted'], item_status: '', is_visible: true
  },
  {id: 4, name: 'Pending Dispatch', slug: 'pending_dispatch', color: '#f9c74f', is_partial_status: false,
    before_status: ['Part Accepted', 'All Accepted'], item_status: '', is_visible: true
  },
  {id: 5, name: 'All Dispatched', slug: 'all_dispatched', color: '#006d77', is_partial_status: false,
    before_status: ['Pending Dispatch'], item_status: '', is_visible: true
  },
  {id: 6, name: 'Part Dispatched', slug: 'part_dispatched', color: '#219ebc', is_partial_status: true,
    before_status: ['Pending Dispatch', 'Part Dispatched'], item_status: 'Not Dispatched', is_visible: true
  },
  {id: 7, name: 'All Received', slug: 'all_received', color: '#006d77', is_partial_status: false,
    before_status: ['All Dispatched'], item_status: '', is_visible: false
  },
  {id: 8, name: 'Part Received', slug: 'part_received', color: '#d62828', is_partial_status: true,
    before_status: ['All Dispatched', 'Part Dispatched', 'Part Received'], item_status: 'Not Received', is_visible: false
  },
  {id: 9, name: 'All Returned', slug: 'all_return', color: '#3a0ca3', is_partial_status: false,
    before_status: ['All Received'], item_status: '', is_visible: false
  },
  {id: 10, name: 'Part Returned', slug: 'part_return', color: '#3a0ca3', is_partial_status: true,
    before_status: ['All Received', 'Part Received', 'Part Returned'], item_status: 'Not Returned', is_visible: false
  },
  {id: 11, name: 'Goods Not Received', slug: 'goods_not_received', color: '#f72585', is_partial_status: false,
    before_status: ['All Dispatched', 'Part Dispatched'], item_status: '', is_visible: false
  },
  {id: 12, name: 'Order Cancelled', slug: 'order_cancelled', color: '#d62828', is_partial_status: false,
    before_status: ['Order Submitted'], item_status: '', is_visible: true
  },
]
